import { useMemo } from 'react';
import { usePractice } from '../../../providers/practices/PracticesProvider';
import type { PatientListItemType } from '../../../providers/patient/PatientsListProvider';

interface PracticeCellProps {
    patient: PatientListItemType;
}

/** Comma-joined practice name(s) for a patient, resolved from the practice id list. */
export function PracticeCell({ patient }: PracticeCellProps) {
    const { practices, isLoading: isPracticesLoading } = usePractice();

    const practiceNames = useMemo(() => {
        const ids = patient.practiceIds;
        if (!ids || !Array.isArray(ids) || ids.length === 0) return null;
        if (isPracticesLoading) return 'loading';

        const names = ids
            .map((id) => practices.find((p) => p.id === String(id))?.name)
            .filter(Boolean);

        return names.length > 0 ? names.join(', ') : null;
    }, [patient.practiceIds, practices, isPracticesLoading]);

    if (practiceNames === 'loading') {
        return <span className="inline-block w-20 h-4 bg-gray-200 rounded animate-pulse" />;
    }

    return (
        <span className="text-sm text-gray-600 block truncate" title={practiceNames || undefined}>
            {practiceNames || '-'}
        </span>
    );
}
